module.exports = __webpack_public_path__ + "img/xmasParty11.21665de1.jpg";